
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/grade-summary/jst/accessibleLineGraph';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <tr>\n      <td scope=\"row\">"
    + escapeExpression((helper = helpers.tDateToString || (depth0 && depth0.tDateToString),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.date), "medium", options) : helperMissing.call(depth0, "tDateToString", (depth0 && depth0.date), "medium", options)))
    + "</td>\n      <td>"
    + escapeExpression((helper = helpers.nf || (depth0 && depth0.nf),options={hash:{
    'format': ("outcomeScore")
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.y), options) : helperMissing.call(depth0, "nf", (depth0 && depth0.y), options)))
    + "</td>\n    </tr>\n  ";
  return buffer;
  }

  buffer += "<table>\n  <caption>\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'current_user_name': ((depth0 && depth0.current_user_name)),
    'outcome_name': ((depth0 && depth0.outcome_name)),
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.accessible_line_graph")
  },data:data},helper ? helper.call(depth0, "the_most_recent_scores_for_user_current_user_name__ea82f0b6", "The most recent scores for user %{current_user_name} and outcome %{outcome_name}.", options) : helperMissing.call(depth0, "t", "the_most_recent_scores_for_user_current_user_name__ea82f0b6", "The most recent scores for user %{current_user_name} and outcome %{outcome_name}.", options)))
    + "\n  </caption>\n  <tr>\n    <th scope=\"col\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.accessible_line_graph")
  },data:data},helper ? helper.call(depth0, "date_ee500367", "Date", options) : helperMissing.call(depth0, "t", "date_ee500367", "Date", options)))
    + "</th>\n    <th scope=\"col\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("outcomes.accessible_line_graph")
  },data:data},helper ? helper.call(depth0, "score_f7ac9e08", "Score", options) : helperMissing.call(depth0, "t", "score_f7ac9e08", "Score", options)))
    + "</th>\n  </tr>\n  ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.data), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</table>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  